import { render, staticRenderFns } from "./CivilStatusList.vue?vue&type=template&id=5fe4ae80"
import script from "./CivilStatusList.vue?vue&type=script&lang=js"
export * from "./CivilStatusList.vue?vue&type=script&lang=js"
import style0 from "./CivilStatusList.vue?vue&type=style&index=0&id=5fe4ae80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports